import { semanticColors, ThemeMode } from '@creditornot/cb-ingredients';
import { mix, opacify, parseToRgb } from 'polished';

export const solidify = (color: string, theme: ThemeMode) => {
  const rgbaColor = parseToRgb(color);
  const alpha = 'alpha' in rgbaColor ? rgbaColor.alpha : 1;
  const baseColor = semanticColors[theme].surfaceMain;
  return mix(1 - alpha, baseColor, opacify(1, color));
};
